document
	.querySelectorAll('.gform-body input, .gform-body textarea')
	.forEach((inputEl) => {
		inputEl.classList.add('gfield--empty');
		inputEl.addEventListener('input', (e) => {
			inputEl.classList.toggle(
				'gfield--empty',
				e.target.value.length === 0
			);
		});
	});
